export enum focusIds {
  CONTENT = 'content',
  CONTAINER_MOD = '_container',
  CLASSIC_HOME = 'classic-home',
  HOME = 'home',
  SPECIAL_HOME = 'special-home',
  HOME_GRID = 'home-grid',
  SPORTS = 'sports',
  CATALOGUE = 'catalogue',
  CALENDAR = 'calendar',
  FAVORITES = 'favorites',
  FOCUS_PAGE = 'focus',
  SIDEBAR = 'sidebar',
  MAIN_MENU = 'main-menu',
  SUB_MENU = 'sub-menu',
  SETTINGS_MENU = 'settings-menu',
  LOGIN = 'login',
  SUBSCRIPTIONS = 'subscriptions',
  OFFERS = 'offers',
  SETTINGS = 'settings',
  SETTINGS_EDIT_SPORTS = 'edit-sports',
  SETTINGS_EDIT_BROADCASTERS = 'edit-broadcasters',
  SETTINGS_SUBSCRIPTIONS = 'subscriptions',
  SETTINGS_ACCOUNT = 'account',
  SETTINGS_IMPRINT = 'imprint',
  SETTINGS_DATA_PRIVACY = 'data-privacy',
  SETTINGS_TERMS_CONDITIONS = 'terms-conditions',
  SETTINGS_DEVELOPER = 'developer',
  SETTINGS_SMART_PREVIEW = 'preview',
  SETTINGS_REGION = 'region',
  EVENT_PAGE = 'event',
  PAGE = 'page',
  SELECTED_PAGE = 'selected',
  CATALOGUE_HOME = 'catalogue-home',
  SQUARE_SLIDER = 'squareSlider',
  FILTER_SLIDER = 'filterSlider',
  BIG_LINE_SLIDER = 'bigLineSlider',
  BUTTON = 'button',
  BUTTON_START = 'buttonStart',
  ICON_BUTTON = 'icon-button',
  REGISTER = 'register',
  CHECKOUT = 'checkout',
  ERROR = 'error',
  ERROR_CONNECTION = 'error_connection',
  SELF_SERVICE = 'selfService',
  LOGOUT = 'logout',
  EXIT = 'exit',
  FULLSCREEN_PLAYER = 'fullscreen_player',
  VOUCHER = 'voucher',
  POPUP = 'popup',
  WATCH_NOW = 'watch_now',
  EVENT_SLIDER = 'event_slider',
  UNLOCK_PREMIUM = 'unlock_premium',
  LIVE_TODAY = 'live_today_0',
  PAGE_POPUP = 'page-popup_',
  CHANNEL_SLIDER = 'ChannelSlider_',
  CHANNEL_ITEM = 'ChannelItem_',
  EVENT_PAGE_LINES_GROUP = 'EventPage_LinesGroup',
  EVENT_PAGE_LINE = 'EventPageLine_',
  LINES_GROUP = 'LinesGroup',
  LINE = 'Line_',
  LINE_LOADER = 'LineLoader',
  LIST = 'list',
  SECTION_GRID_GROUP = 'SectionGridGroup',
  SECTION_GRID = 'SectionGrid',
  SECTION = 'Section_',
  BOX = 'Box',
  SUBSCRIPTION = 'Subscription_',
  PLAYER = 'player',
  USERCENTRICS = 'usercentrics',
  DATA_WIDGET = 'DataWidget',
  SEARCH = 'search',
  SUGGESTIONS = 'Suggestions',
  CONTROLS = 'Controls',
  PAGE_FALLBACK = 'page_fallback',
  VIEW_MORE_FIRST = 'ViewMore-first',
  VIEW_MORE_LAST = 'ViewMore-last',
  VIDEO_CONTAINER = 'video_container',
  FEATURE_SCREEN = 'feature-screen',
  PPV_POPUP = 'ppv_popup',
  AUTH_POPUP = 'auth_popup',
  UNLOCK_WITH_CREDIT = 'unlock_with_credit',
  SETTINGS_HLS_ADS_PLAYER = 'hls-ads-player',
}

export enum orientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum Direction {
  Forward = 'forward',
  Backward = 'backward',
}

export enum Arrow {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}
